import React from 'react'

const Pinterest = (
    props: React.SVGProps<SVGSVGElement>
): React.ReactElement => {
    return (
        <svg
            width="33"
            height="32"
            viewBox="0 0 33 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M32.2081 13.8685C31.0107 3.15739 17.506 -2.63996 8.25973 3.51099C4.4965 6.0119 1.97563 10.1567 1.22837 14.5578C0.715191 17.5979 1.0483 20.8413 2.41682 23.6428C3.78523 26.4354 6.07205 28.7066 9.04301 29.7849C18.2713 33.1518 30.8125 29.5196 32.2081 18.9146C32.4332 17.2445 32.3971 15.5388 32.2081 13.8685Z"
                fill="#534E46"
                stroke="#534E46"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.73 17.8306C8.732 15.1618 10.2829 9.79631 15.4017 8.75681C21.1106 7.59567 24.1171 11.6222 23.3559 15.9578C22.8136 19.0479 19.9497 21.2391 17.1525 20.9675C14.4883 20.7054 13.0896 17.7744 13.6511 15.115C13.7938 14.422 14.1649 13.2047 14.8594 12.9426C15.6966 12.6242 15.3542 14.5251 15.1067 15.5832C14.574 17.8868 13.0516 23.5708 11.4436 25.0221"
                stroke="white"
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default Pinterest
